import { createSlice } from '@reduxjs/toolkit';

import { getImpactReferences } from '@/domain/impact-references/actions/get-impact-references.action';
import {
  EMPTY_REFERENCES,
  References,
} from '@/domain/impact-references/entities/references.entity';

export type ReferencesState = {
  isFetching: boolean;
  references: References;
};

const initialState: ReferencesState = {
  isFetching: false,
  references: EMPTY_REFERENCES,
};

export const impactReferences = createSlice({
  name: 'impactReferences',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getImpactReferences.pending, (state) => {
        state.isFetching = true;
      })
      .addCase(getImpactReferences.fulfilled, (state, action) => {
        state.isFetching = false;
        state.references = action.payload;
      })
      .addCase(getImpactReferences.rejected, (state) => {
        state.isFetching = false;
      });
  },
});
